/**
 * @description VRM Installation Advanced routing
 */

(function() {
    'use strict';

    angular.module('vrm.core')
        .config(AdvancedConfig);

    /**
     * @constructor
     * @ngInject
     */
    function AdvancedConfig($stateProvider) {

        // set available routes
        $stateProvider
            .state('base.installation.advanced', {
                url: '/advanced?&start&end&widgetId',
                views: {
                    "body": {
                        template: require('@/angular/views/core/installation/advanced.html'),
                        controller: 'InstallationAdvancedController'
                    }
                }, 
                data:{
                    sharedCanAccess:true
                }
            });
    }

})();
